import { useQuery } from 'data-fetching-client';
import { FETCH_INDUSTRY_NAME } from 'messaging-publishing-lib/Insights/queries';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
const useFetchIndustryName = () => {
  var _data$industryName;
  const {
    data
  } = useQuery(FETCH_INDUSTRY_NAME);
  const industryKey = data === null || data === void 0 || (_data$industryName = data.industryName) === null || _data$industryName === void 0 ? void 0 : _data$industryName.industry;
  const industryName = isValidI18nKey(`industry.${industryKey}`) ? I18n.text(`industry.${industryKey}`) : undefined;
  return {
    industryName
  };
};
export default useFetchIndustryName;